<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container>
            <el-header>
                <div class="search-ctn">
                    <div class="search-ctn-left">
                        <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="showAddDingTalk()">添加钉钉打卡机</el-button>
                        <span style="color: grey">（ ※ 钉钉打卡机只需添加一条配置即可，即使你有多台打卡机也不需要添加多条配置 ）</span>
                    </div>
                </div>
            </el-header>
            <el-container style="height: 100%">
                <el-main width="100%" height="100%" style="padding-top: 0px">
                    <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="attendanceDeviceList" border="" style="width: 100%">
                        <el-table-column width="250px" prop="DeviceName" label="设备标识">
                            <template slot-scope="scope">
                                <span>{{ scope.row.DType == 0 ? scope.row.DeviceName : '钉钉考勤机' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="300px" prop="DeviceSN" label="序列号"></el-table-column>
                        <el-table-column min-width="300px" prop="DeviceAddress" label="设备地址"></el-table-column>
                        <el-table-column min-width="150px" prop="StateName" label="是否在线"></el-table-column>
                        <el-table-column min-width="200px" prop="CreateTime" label="创建时间"></el-table-column>
                        <el-table-column label="操作" :autoWidth="true">
                            <template slot-scope="scope">
                                <div class="ops-ctn">
                                    <el-button type="text" size="mini" v-if="permission.check && scope.row.DType == 0" @click="showAttendanceDevicesInfoe(scope)">{{
                                        permission.check
                                    }}</el-button>
                                    <el-button type="text" size="mini" v-if="permission.edit && scope.row.DType == 0" @click="showEditAttendanceDevice(scope)">{{
                                        permission.edit
                                    }}</el-button>
                                    <el-button type="text" size="mini" @click="showEntpStaffListByDeviceId(scope)" v-if="permission.uploadstaff && scope.row.DType == 0">{{
                                        permission.uploadstaff
                                    }}</el-button>
                                    <el-button type="text" size="mini" v-if="permission.uploaddep && scope.row.DType == 0" @click="addDeptDataInstructions(scope)">{{
                                        permission.uploaddep
                                    }}</el-button>
                                    <el-button type="text" size="mini" @click="addRestartDeviceInstructions(scope)" v-if="permission.reset && scope.row.DType == 0">{{
                                        permission.reset
                                    }}</el-button>
                                    <el-button type="text" size="mini" v-if="permission.edit && scope.row.DType == 1" @click="showSetDingDevice(scope.row)">{{
                                        permission.edit
                                    }}</el-button>
                                    <el-button type="text" size="mini" @click="showStaffDingDevice(scope.row)" v-if="permission.uploadstaff && scope.row.DType == 1">{{
                                        permission.uploadstaff
                                    }}</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <div class="pagination-ctn">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchData.page"
                        :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                        :page-size="searchData.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="attendanceDeviceList.length"
                    ></el-pagination>
                </div>
            </el-container>
            <!-- 更新设备信息 -->
            <el-dialog title="设备信息" :visible.sync="edit_dialogVisible" width="400px">
                <el-form :model="attendanceDevice" style="padding-top: 25px">
                    <el-row>
                        <el-form-item label="设备名称">
                            <el-input style="width: 290px" v-model="attendanceDevice.deviceName" placeholder="设备名称"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="设备地址">
                            <el-input style="width: 290px" v-model="attendanceDevice.deviceAddress" placeholder="设备地址"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row type="flex" justify="end" style="margin-bottom: 15px">
                        <el-button size="small" class="btn-primary" @click="dialogHandleClose">取消</el-button>
                        <el-button size="small" class="btn-primary" @click="editAttendanceDevice">提交</el-button>
                    </el-row>
                </el-form>
            </el-dialog>
            <!-- 查看设备信息 -->
            <el-dialog title="设备信息" :visible.sync="check_dialogVisible" width="850px">
                <el-form :model="attendanceDeviceInfo" label-width="100px" style="padding-top: 25px">
                    <el-row>
                        <!-- <el-col :span="12">
              <el-form-item label="设备型号">
                <el-input
                  style="width:290px"
                  :disabled="true"
                  v-model="attendanceDeviceInfo.Model"
                  placeholder="设备型号"
                ></el-input>
              </el-form-item>
                        </el-col>-->
                        <el-col :span="12">
                            <el-form-item label="设备版本号">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.Rom" placeholder="设备版本号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="应用版本号">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.App" placeholder="应用版本号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="sd卡剩余空间">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.Space" placeholder="sd卡剩余空间"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="剩余内存">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.Memory" placeholder="剩余内存"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="用户数">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.UserCount" placeholder="用户数"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="指纹数">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.FingerprintCount" placeholder="指纹数"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="人脸数">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.FaceCount" placeholder="人脸数"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="头像数量">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.HeadPicCount" placeholder="头像数量"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="打卡记录数量">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.ClockinCount" placeholder="打卡记录数量"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="现场照片数量">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.PicCount" placeholder="现场照片数量"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="创建时间">
                                <el-input style="width: 290px" :disabled="true" v-model="attendanceDeviceInfo.CreateTime" placeholder="创建时间"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addUploadDeviceInfoInstructions">上传设备</el-button>
                </span>
            </el-dialog>
            <!-- 上传数据 -->
            <el-dialog title="人员选择" :visible.sync="upload_dialogVisible" width="680px">
                <el-row style="margin: 20px">
                    <el-cascader style="width: 200px" :options="orgSearchData" :props="cascaderProps" :show-all-levels="false" clearable @change="cascaderOnChange">
                        <template slot-scope="{ node, data }">
                            <span>{{ data.Name }}</span>
                        </template>
                    </el-cascader>
                    <el-transfer
                        filterable
                        :titles="['员工列表', '已同步员工']"
                        :filter-method="transferfilter"
                        filter-placeholder="请输入关键字"
                        v-model="rightStaffList"
                        :data="leftStaffList"
                        :props="transferProps"
                        @change="onTransferChange"
                    >
                        <span slot-scope="{ option }">{{ option.Name }}</span>
                    </el-transfer>
                </el-row>
                <el-row type="flex" justify="end" style="margin: 0px 35px 15px 0px">
                    <el-button class="btn-primary" size="small" @click="upload_dialogVisible = false">取消</el-button>
                    <el-button class="btn-primary" size="small" @click="addUserDataInstructions">上传员工</el-button>
                </el-row>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="钉钉配置信息" :visible.sync="dingSet_dialogVisible" width="1000px">
                <div class="dialog-content" v-if="dingSet_dialogVisible">
                    <DevicesEdit ref="divicesEdit" :DeviceId="deviceId" @closeDialog="closeSetDingDialog"></DevicesEdit>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="关联钉钉的员工数据" :visible.sync="dingStaff_dialogVisible" width="800px">
                <div class="dialog-content" v-if="dingStaff_dialogVisible">
                    <SyncStaffDatas
                        ref="syncStaffDatas"
                        :DeviceId="deviceId"
                        @closeDialog="
                            () => {
                                this.dingStaff_dialogVisible = false;
                            }
                        "
                    ></SyncStaffDatas>
                </div>
            </el-dialog>
        </el-container>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import DevicesEdit from '@/components/business/attendanceSystem/devicesEdit';
import SyncStaffDatas from '@/components/business/attendanceSystem/syncStaffDatas';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        DevicesEdit,
        SyncStaffDatas
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            edit_dialogVisible: false,
            check_dialogVisible: false,
            upload_dialogVisible: false,
            dingSet_dialogVisible: false,
            dingStaff_dialogVisible: false,
            entpId: userMsg.EntpId,
            permission: {},
            searchData: {
                entpId: userMsg.EntpId,
                name: '',
                sn: '',
                state: '',
                page: 1,
                limit: 15
            },
            attendanceDeviceList: [],
            deviceId: '',
            attendanceDeviceInfo: {
                EntpId: '',
                DeviceId: '',
                /// 设备型号
                Model: '',
                /// 系统版本号
                Rom: '',
                /// 应用版本号
                App: '',
                /// sd卡剩余空间
                Space: '',
                /// 剩余内存
                Memory: '',
                /// 用户数
                UserCount: '',
                /// 指纹数
                FingerprintCount: '',
                /// 人脸数
                FaceCount: '',
                /// 头像数量
                HeadPicCount: '',
                /// 打卡记录数量
                ClockinCount: '',
                /// 现场照片数量
                PicCount: '',
                /// 创建时间
                CreateTime: ''
            },
            attendanceDevice: {
                deviceId: '',
                deviceName: '',
                deviceAddress: ''
            },
            leftStaffList: [], //只是展示左侧列表的数据,不作上传
            orginEntpStaffList: [], //保留原始的数据,做匹配和还原
            rightStaffList: [], //只是展示右侧列表的数据,不作上传
            // uploadStaffList: [], //最终上传的数组
            transferProps: {
                key: 'Id',
                label: 'Name',
                action: 'action'
            },
            orgSearchData: [],
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                key: 'CascadeId',
                checkStrictly: true
            },
            tempCurrentDeviceId: '',
            tempCascadeId: '',
            transferfilter(query, item) {
                return item.Name.indexOf(query) > -1;
            }
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('AttendanceDevices');
        this.getOrgTree();
        this.getAttendanceDeviceList();
    },
    methods: {
        showAddDingTalk() {
            this.dingSet_dialogVisible = true;
        },
        showStaffDingDevice(item) {
            if (item) {
                this.deviceId = item.Id;
                this.dingStaff_dialogVisible = true;
            }
        },
        showSetDingDevice(item) {
            if (item) {
                this.deviceId = item.Id;
                this.dingSet_dialogVisible = true;
            }
        },
        closeSetDingDialog(isEdit) {
            this.dingSet_dialogVisible = false;
            if (isEdit) this.getAttendanceDeviceList();
        },
        //获取设备列表
        getAttendanceDeviceList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetAttendanceDeviceList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.attendanceDeviceList = res.data;
                    }
                })
                .catch(err => {});
        },
        //添加上传设备信息命令
        addUploadDeviceInfoInstructions() {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/AddUploadDeviceInfoInstructions',
                    data: {
                        entpId: this.entpId,
                        deviceId: this.attendanceDeviceInfo.DeviceId
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('上传成功');
                    }
                })
                .catch(err => {});
        },
        //显示设备详细信息
        showAttendanceDevicesInfoe(scope) {
            this.getAttendanceDevicesInfoe(scope);
        },
        //获取设备信息
        getAttendanceDevicesInfoe(scope) {
            let _deviceId = scope.row.Id;
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetAttendanceDevicesInfoe',
                    data: { deviceId: _deviceId }
                })
                .then(res => {
                    this.check_dialogVisible = true;
                    if (res.data) {
                        this.attendanceDeviceInfo = res.data;
                    }
                })
                .catch(err => {});
        },
        //显示更新设备信息Dialog
        showEditAttendanceDevice(scope) {
            this.attendanceDevice.deviceId = scope.row.Id;
            this.attendanceDevice.deviceAddress = scope.row.DeviceAddress;
            this.attendanceDevice.deviceName = scope.row.DeviceName;
            this.edit_dialogVisible = true;
        },
        //更新设备信息
        editAttendanceDevice() {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/EditAttendanceDevice',
                    data: {
                        deviceId: this.attendanceDevice.deviceId,
                        deviceName: this.attendanceDevice.deviceName,
                        deviceAddress: this.attendanceDevice.deviceAddress
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.getAttendanceDeviceList();
                        this.$util.successMsg('更新成功');
                        this.dialogHandleClose();
                    }
                })
                .catch(err => {});
        },
        //重启设备
        addRestartDeviceInstructions(scope) {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/AddRestartDeviceInstructions',
                    data: {
                        entpId: this.entpId,
                        deviceId: scope.row.Id
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('重启成功');
                    }
                })
                .catch(err => {});
        },
        showEntpStaffListByDeviceId(scope) {
            this.upload_dialogVisible = true;
            this.getEntpStaffListByDeviceId(scope);
        },
        //获取企业员工列表
        getEntpStaffListByDeviceId(scope) {
            this.leftStaffList = [];
            this.orginEntpStaffList = [];
            this.rightStaffList = [];
            //这个deviceId给上传数据用
            this.tempCurrentDeviceId = scope.row.Id;

            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetEntpStaffListByDeviceId',
                    data: {
                        entpId: this.entpId,
                        deviceId: scope.row.Id
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.leftStaffList = res.data;
                        for (let index = 0; index < this.leftStaffList.length; index++) {
                            const element = this.leftStaffList[index];
                            if (element.IsSync) {
                                this.rightStaffList.push(element.Id);
                            }
                        }
                        this.orginEntpStaffList = res.data;
                    }
                })
                .catch(err => {});
        },
        //获取企业部门列表
        getOrgTree() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetOrgTree'
                })
                .then(res => {
                    if (res.data) {
                        this.orgSearchData = this.getTreeData(res.data);
                    }
                })
                .catch(err => {});
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        onTransferChange(list, direction, moveValue) {
            this.staffListFilter(moveValue, direction);
        },
        staffListFilter(IdList, direction) {
            let time = IdList.length;
            for (let index = 0; index < this.orginEntpStaffList.length; index++) {
                for (let j = 0; j < IdList.length; j++) {
                    const _Id = IdList[j];

                    if (this.orginEntpStaffList[index].Id == _Id) {
                        if (direction == 'right') {
                            if (this.orginEntpStaffList[index].IsSync == true) {
                                this.orginEntpStaffList[index].action = 'updata';
                            } else {
                                this.orginEntpStaffList[index].action = 'add';
                            }
                        } else if (direction == 'left') {
                            this.orginEntpStaffList[index].action = 'del';
                        }
                        time--;
                        if (time == 0) {
                            index = this.orginEntpStaffList.length;
                        }
                    }
                }
            }
        },
        //通过部门筛选员工
        cascaderOnChange(value) {
            this.tempCascadeId = '';
            if (value != null) {
                this.searchOrgCascadeId(value, this.orgSearchData[0].Childrens);
                let tempList = [];
                this.leftStaffList = this.orginEntpStaffList;
                for (let index = 0; index < this.leftStaffList.length; index++) {
                    const element = this.leftStaffList[index];
                    if (element.CascadeId.indexOf(this.tempCascadeId) > -1) {
                        tempList.push(element);
                    }
                }
                this.leftStaffList = tempList;
            } else {
                this.leftStaffList = this.orginEntpStaffList;
            }
        },
        //递归所有部门,通过Id匹配CascadeId
        searchOrgCascadeId(key, data) {
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (key == element.Id) {
                    this.tempCascadeId = element.CascadeId;
                } else {
                    if (element.Childrens.length > 0) {
                        this.searchOrgCascadeId(key, element.Childrens);
                    }
                }
            }
        },
        //上传员工数据
        addUserDataInstructions() {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/AddUserDataInstructions',
                    data: {
                        entpId: this.entpId,
                        deviceId: this.tempCurrentDeviceId,
                        staffs: this.orginEntpStaffList
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.upload_dialogVisible = false;
                        this.$util.successMsg('同步成功');
                    }
                })
                .catch(err => {});
        },
        //上传部门数据
        addDeptDataInstructions(scope) {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/AddDeptDataInstructions',
                    data: {
                        entpId: this.entpId,
                        deviceId: scope.row.Id
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.upload_dialogVisible = false;
                        this.$util.successMsg('同步成功');
                    }
                })
                .catch(err => {});
        },
        // 分页处理
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getAttendanceDeviceList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getAttendanceDeviceList();
        },
        dialogHandleClose() {
            this.edit_dialogVisible = false;
        }
    }
};
</script>
<style lang="less" scoped></style>
